import {
    GetBoxSharingInfoResponse,
    GetDropboxSharingInfoResponse,
    GetGDriveSharingInfoResponse,
    GetODCSharingInfoResponse,
    GetSharingInfoResponseBase,
} from 'owa-fileprovider-link-services';
import { AnchorElementsSource } from 'owa-link-data';
import { LinkProviderType } from 'owa-fileprovider-link';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { createLinkModelForBox } from './createLinkModelForBox';
import { createLinkModelForDropbox } from './createLinkModelForDropbox';
import { createLinkModelForGDrive } from './createLinkModelForGDrive';
import { createLinkModelForODB } from './createLinkModelForODB';
import { createLinkModelForODC } from './createLinkModelForODC';

export function createLinkModel(
    linkId: string,
    url: string,
    response: GetSharingInfoResponseBase | null,
    source: AnchorElementsSource,
    providerType: LinkProviderType,
    unwrappedUrl: string,
    creationDateTime: string
): SharingLinkInfo {
    switch (providerType) {
        case LinkProviderType.OneDrivePro:
        case LinkProviderType.OfficeOneDrivePro:
            return createLinkModelForODB(
                linkId,
                url,
                <GetSharingInfoResponse>response,
                source,
                unwrappedUrl,
                creationDateTime
            );
        case LinkProviderType.OneDriveConsumer:
            return createLinkModelForODC(
                linkId,
                url,
                <GetODCSharingInfoResponse>response,
                source,
                unwrappedUrl
            );
        case LinkProviderType.Dropbox:
            return createLinkModelForDropbox(
                linkId,
                url,
                <GetDropboxSharingInfoResponse>response,
                source,
                unwrappedUrl
            );
        case LinkProviderType.Box:
            return createLinkModelForBox(
                linkId,
                url,
                <GetBoxSharingInfoResponse>response,
                source,
                unwrappedUrl
            );
        case LinkProviderType.GDrive:
            return createLinkModelForGDrive(
                linkId,
                url,
                <GetGDriveSharingInfoResponse>response,
                source,
                unwrappedUrl
            );
        default:
            throw new Error('createLinkModel do not support ${providerType}');
    }
}
